import React from 'react';
import { CheckCircle, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';

const fadeInUp = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const AllPetCardSection = () => {
  return (
    <motion.section
      className="section-padding bg-[#F5F5F0]"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={fadeInUp}
      data-testid="allpet-card-section"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid lg:grid-cols-5 gap-0">
              {/* Left: Dog Photo */}
              <div className="lg:col-span-2 relative">
                <img
                  src="/assets/images/allpet-dog.png"
                  alt="All Pet Card - Happy Dog"
                  className="w-full h-full object-cover min-h-[320px]"
                  data-testid="allpet-dog-image"
                />
              </div>

              {/* Right: Content */}
              <div className="lg:col-span-3 p-8 lg:p-10">
                <div className="flex items-center gap-4 mb-5">
                  <img
                    src="/assets/images/allpet-circle-logo.png"
                    alt="All Pet Card Logo"
                    className="w-16 h-16 object-contain"
                    data-testid="allpet-logo"
                  />
                  <h2 className="text-3xl lg:text-4xl font-bold text-[#5C4033]" style={{ fontFamily: 'Playfair Display, serif' }}>
                    We Accept the All Pet Card
                  </h2>
                </div>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  A simple, affordable way to get the training your pet needs — and pay over time. No down payment or annual fee.
                </p>

                <div className="space-y-3 mb-8">
                  <div className="flex items-start gap-3">
                    <CheckCircle className="text-[#C4A052] flex-shrink-0 mt-0.5" size={20} />
                    <span className="text-gray-700"><strong>No interest</strong> if paid in full within 6 months on purchases of $250 or more</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="text-[#C4A052] flex-shrink-0 mt-0.5" size={20} />
                    <span className="text-gray-700"><strong>No down payment</strong> or annual fee</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="text-[#C4A052] flex-shrink-0 mt-0.5" size={20} />
                    <span className="text-gray-700"><strong>Use again and again</strong> for training, boarding, and pet care</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="text-[#C4A052] flex-shrink-0 mt-0.5" size={20} />
                    <span className="text-gray-700"><strong>Fast prequalification</strong> with no impact to your credit score</span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-4">
                  <a
                    href="https://allpet.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button
                      className="bg-gradient-to-r from-[#C4A052] to-[#B8935E] hover:from-[#B8935E] hover:to-[#C4A052] text-white font-semibold px-8 py-6 text-lg rounded-lg transition-all duration-300 hover:shadow-xl hover:scale-105"
                      data-testid="allpet-apply-now-btn"
                    >
                      <ExternalLink className="mr-2" size={20} /> Apply Now
                    </Button>
                  </a>
                </div>

                <p className="text-xs text-gray-400 mt-4 leading-relaxed">
                  All Pet Card credit card accounts are issued by Comenity Capital Bank. Subject to credit approval. No interest if paid in full within 6 months on purchases of $250 or more made with your All Pet Card. Interest will be charged from the purchase date if the promotional balance is not paid in full within 6 months.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default AllPetCardSection;
